export default __webpack_public_path__ + "static/webRotator/svg/de3a680c096d378adb035afb83451b49.svg";